// Column sizing shared by the table header (ItemsTable) and every body row
// (DashboardRow) so the flexbox columns line up exactly — the same
// fixed-width-per-column approach the /operations table uses. `service` is the
// only growable column (flex-grow); the rest are pinned. Keep this in sync with
// the `HEADERS` order in items-table.tsx.
export const DASHBOARD_COLUMNS = {
  select: '44px',
  when: '120px',
  itinerary: '180px',
  location: '120px',
  // XT-380 drill-in list: owner (itinerary account) as its own column.
  owner: '120px',
  operator: '150px',
  // Wide enough for the long org status titles ("S1: Non Requested",
  // "S4: Confirm Assignment") the Badge shows; longer ones ellipsis cleanly.
  status: '150px',
  actions: '72px',
} as const;

// Growable "Service" column's preferred size (flex-basis); it eats the leftover
// width via flex-grow.
export const SERVICE_BASIS = '200px';

// Horizontal scroll floor for a `<TableContainer scrollable>`: the sum of every
// column's base (fixed widths + the service basis). Below it the table scrolls
// sideways instead of squashing, so the columns never drift out of alignment.
// + owner column (120px) vs the pre-XT-380 floor.
export const DASHBOARD_ROW_MIN = '1216px';
